module.exports = __webpack_public_path__ + "media/images/emoticons/on-0f0e50ca321abc999f202ba2f9337625.gif";